import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface RequestQuery {
    list_no: string;
}

interface RequestBody {
    result: string;
}

export type UpdateRequest = RequestQuery & RequestBody;

export interface UpdateResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

export const usePutConsoleQrSystem = (
    successCallback?: (data: UpdateResponse) => void,
): UseMutationResult<UpdateResponse, Error, UpdateRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<UpdateResponse, Error, UpdateRequest>({
        mutationFn: async (updateData: UpdateRequest) => {
            const url = enum_api_uri.put_console_qr_system_request.replace(":list_no", updateData.list_no);

            const response = await axiosInstance.put(url, {
                result: updateData.result,
            });
            return response.data.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleQrSystem"] });
            successCallback?.(data);
        },
    });
};
